import PolarisDocumentAPI from 'dashboard/api/polaris/document';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import { createStore } from '../storeFactory';

const SYNCING_STATE = 'syncing';

const markRecordsSyncing = (records, ids) => {
  const idSet = new Set(ids);
  return records.map(record =>
    idSet.has(record.id)
      ? {
          ...record,
          sync_status: SYNCING_STATE,
          sync_in_progress: true,
          last_sync_attempted_at: Math.floor(Date.now() / 1000),
          last_sync_error_code: null,
        }
      : record
  );
};

export default createStore({
  name: 'PolarisDocument',
  API: PolarisDocumentAPI,
  getters: {
    getRecords: state => state.records,
  },
  actions: mutations => ({
    setFetchingList({ commit }, isFetching) {
      commit(mutations.SET_UI_FLAG, { fetchingList: isFetching });
    },
    setRecords({ commit }, { records, meta }) {
      commit(mutations.SET, records);
      commit(mutations.SET_META, meta);
    },
    removeBulkRecords({ commit, getters }, ids) {
      const records = getters.getRecords.filter(
        record => !ids.includes(record.id)
      );
      commit(mutations.SET, records);
    },
    markSyncing({ commit, getters }, ids) {
      commit(mutations.SET, markRecordsSyncing(getters.getRecords, ids));
    },
    async sync({ dispatch }, id) {
      try {
        await PolarisDocumentAPI.sync(id);
        dispatch('markSyncing', [id]);
        return id;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
    // Liga/desliga um assistente na fonte; a resposta é o documento atualizado (assistant_ids novo).
    async setAssistantAccess({ commit }, { id, assistantId, allowed }) {
      const request = allowed
        ? PolarisDocumentAPI.attachAssistant(id, assistantId)
        : PolarisDocumentAPI.detachAssistant(id, assistantId);
      try {
        const response = await request;
        commit(mutations.EDIT, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
  }),
});
